import React from 'react';
import PropTypes from 'prop-types';
import { parse, componentMap } from '../shared/helpers';
import uuid from '../../../../helpers/uuid';

const getComponent = (node) => {
  const { text, tagName, value } = node;
  const componentConfig = componentMap[tagName];

  if (componentConfig) {
    const { component: Component, valueProp } = componentConfig;
    const props = {
      key: uuid(),
      ...valueProp && value && { [valueProp]: value },
    };
    return <Component {...props}>{text}</Component>;
  }

  return text;
};

const BBCodeParser = ({ children }) => parse(children).map(getComponent);

BBCodeParser.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BBCodeParser;
